import { MARK_ITEM } from '@doltech/ui/lib/figma/BlankEditor/type';
import { FontSizeElementVariants } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/components/FontSizeSwitcherElement.types';
import { COUNT_ITEM } from '@doltech/ui/lib/figma/Editor/utils';
import { MarkedByEnum, PassageTypeEnum } from '@doltech/utils/lib/constants';
import { numberToABC, numberToRoman } from '@doltech/utils/lib/text';
import { types as t } from 'mobx-state-tree';

import { Paragraph } from '../../paragraph.store';
import { AbstractPassage } from '../abstract-passage.store';

const SYMBOL_SEPARATOR = '$_$';

export const AnnotatedPassage = AbstractPassage.named('AnnotatedPassage')
  .props({
    type: PassageTypeEnum.ANNOTATE,
    markedBy: t.optional(t.maybeNull<any>(t.string), MarkedByEnum.ALPHABET),
    paragraphs: t.optional(t.array(Paragraph), [{ content: '' }]),
  })
  .views((self) => ({
    get totalParagraphs() {
      return self.paragraphs.length;
    },
    getPassage() {
      const convertFn = self.markedBy === MarkedByEnum.ALPHABET ? numberToABC : numberToRoman;
      const editorObj = [
        {
          type: FontSizeElementVariants.H1,
          children: [{ text: self.title }],
        },
      ];

      if (self.subTitle) {
        editorObj.push({
          type: FontSizeElementVariants.H2,
          children: [{ text: `${self.subTitle}` }],
        });
      }

      editorObj.push(
        ...(self?.paragraphs || [])
          .map((item, index) => [
            {
              type: FontSizeElementVariants.PARAGRAPH_BULLET,
              children: [
                {
                  text: convertFn(index + 1),
                },
              ],
            },
            {
              type: FontSizeElementVariants.PARAGRAPH,
              paragraphIndex: convertFn(index + 1),
              children: [
                {
                  text: item.content,
                },
              ],
            },
          ])
          .reduce((acc, val) => acc.concat(val), [])
      );

      return editorObj;
    },
    getSelectedPassage() {
      const convertFn = self.markedBy === MarkedByEnum.ALPHABET ? numberToABC : numberToRoman;
      const editorObj = [];
      editorObj.push(
        ...(self?.paragraphs || [])
          .map((item, index) => [
            {
              type: FontSizeElementVariants.PARAGRAPH_BULLET,
              isVoid: true,
              children: [
                {
                  text: convertFn(index + 1),
                },
              ],
            },
            {
              type: FontSizeElementVariants.PARAGRAPH,
              paragraphIndex: convertFn(index + 1),
              children: [
                {
                  text: item.content,
                },
              ],
            },
          ])
          .reduce((acc, val) => acc.concat(val), [])
      );

      return editorObj;
    },
  }))
  .views((self) => ({
    getPassageParagraph({ explanation, isLocateExplanation }) {
      let passages = self.getSelectedPassage();
      if (isLocateExplanation) {
        passages = passages.map((paragraph) => {
          const { children } = paragraph;
          const nodes = [];
          children.forEach((node) => {
            const { text } = node;
            const replaceText = text.replace(explanation.selectedPassage, () => {
              return `${SYMBOL_SEPARATOR}${explanation.locatedPassage}${SYMBOL_SEPARATOR}`;
            });
            if (replaceText.includes(SYMBOL_SEPARATOR)) {
              nodes.push({ type: MARK_ITEM, children: [{ text: '' }] });
              replaceText
                .split(SYMBOL_SEPARATOR)
                .filter((item) => item !== SYMBOL_SEPARATOR)
                .forEach((item) => {
                  try {
                    const childrens = JSON.parse(item).map((n) => n.children);
                    childrens.forEach((child) => {
                      child.forEach((n) => {
                        if (n.type !== COUNT_ITEM) {
                          nodes.push(n);
                        }
                      });
                    });
                    return;
                    // eslint-disable-next-line no-empty
                  } catch (ex) {}
                  nodes.push({ text: item });
                });
              return;
            }
            nodes.push({ text });
          });
          if (nodes.length > 0) {
            paragraph.children = nodes;
          }
          return paragraph;
        });
      }

      return passages;
    },
  }));
